import { ExtendedIngredientDTO } from 'business/models/Models';
import { RMTableHeadingWithAddRemoveBtns } from 'components/customComponents/Controls/RMTableHeadingWithAddRemoveBtns';
import React from 'react';
import { MergeIngredientType } from '../IngredientEnums';
import _, { cloneDeep } from 'lodash';
import { MergeIngredientItemsListProps } from '../IngredientConstants';
import { AddMergeIngredientProps } from './MergeIngredientConstants';

export const MergeIngredientItemsList = (props: MergeIngredientItemsListProps) => {
  const {
    name,
    iterator,
    selectedIteratorItems,
    onClickAdd,
    onClickDelete,
    showButtons,
    propertyName,
    ingredient,
    tempIngredient,
    setTempIngredient,
    mergeIngredientType,
    currentMergeIngredientType,
    setMergeIngredientType,
    setMergeIngredient,
  } = props;
  const selectOrUnselect = (selectedIteratorItems: any, item: any) => {
    let isExist = false;
    if (!selectedIteratorItems || mergeIngredientType !== currentMergeIngredientType) {
      selectedIteratorItems = [];
    } else {
      isExist = selectedIteratorItems?.some((type) => _.isEqual(type, item));
    }
    if (isExist === false) {
      selectedIteratorItems.push(item);
    } else {
      const tempItemFiltered = selectedIteratorItems?.filter(
        (type) => !_.isEqual(type, item),
      );
      selectedIteratorItems = tempItemFiltered;
    }

    if (mergeIngredientType !== currentMergeIngredientType) {
      setMergeIngredientType(currentMergeIngredientType);
    }

    return selectedIteratorItems;
  };
  const mergeIngredientObj: AddMergeIngredientProps = {
    ing: tempIngredient,
    property: propertyName,
    mergeIngredient: ingredient,
    setMergeIngredient: setMergeIngredient,
    setTempIngredient: setTempIngredient,
  };
  return (
    <>
      <div id='mergeingredientitemslist-container' className="list-container">
        <RMTableHeadingWithAddRemoveBtns
          tableHeading={name}
          onClickAddBtn={() => {
            onClickAdd(cloneDeep(mergeIngredientObj));
          }}
          onClickRemoveBtn={() => {
            const ing = ingredient;
            ing[propertyName] = [];
            onClickDelete(cloneDeep(ing));
          }}
          showAddButton={showButtons}
          showDeleteButton={showButtons}
        ></RMTableHeadingWithAddRemoveBtns>
        <div id='mergeingredientitemslist-wizardlist' className="wizard-list incoming-ingredients-list">
          {iterator?.map((item, i) => {
            item.name = item.name ? item.name : item.number;
            return (
              <div id={`mergeingredientitemslist-item-${i}`}
                key={`itr${i}`}
                className={`ingredient-wizard-list-item wizard-list-item ${
                  selectedIteratorItems?.some(
                    (lItem) =>
                      _.isEqual(lItem, item) &&
                      mergeIngredientType !== MergeIngredientType.MergeIngredient &&
                      mergeIngredientType === currentMergeIngredientType,
                  )
                    ? 'wizard-list-item-active'
                    : ''
                }`}
                onClick={() => {
                  if (
                    currentMergeIngredientType !== MergeIngredientType.MergeIngredient
                  ) {
                    const tempItems = selectOrUnselect(selectedIteratorItems, item);
                    const tempIngr = new ExtendedIngredientDTO();
                    tempIngr[propertyName] = tempItems;
                    setTempIngredient(cloneDeep(tempIngr));
                  }
                }}
              >
                 <span id={`mergeingredientitemslist-item-${item.name}-label`}>
                {item.name}
              </span>
              </div>
            );  
          })}
        </div>
      </div>
    </>
  );
};
